import React, { useEffect, useState } from "react";
import { FormattedMessage, IntlProvider, useIntl } from "react-intl";
import Header from "./Header";
import Footer from "./Footer";
import enMessages from "../locales/en.json";
import zhMessages from "../locales/zh.json";
import ptMessages from "../locales/pt.json";
import viMessages from "../locales/vi.json";
const supportedLanguages = [
  "en",
  "zh",
  "pt",
  "vi",
]; // Add your supported languages here

function UserGuide(props) {
  const intl = useIntl();
  const browserLanguage = (navigator.language || navigator.userLanguage).split(
    "-"
  )[0];

  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const messages = {
    en: enMessages,
    zh: zhMessages,
    pt: ptMessages,
    vi: viMessages,
  };

  const handleLanguageChange = (e) => {
    const language = e.currentTarget.getAttribute("value");
    localStorage.setItem("selectedLanguage", language); // Store selected language

    // Delay the language change logic for 3 seconds after reload
    setTimeout(() => {
      setSelectedLanguage(language); // Update the language state after 3 seconds
    }, 3000);

    // Reload the page immediately
    window.location.reload();
  };

  useEffect(() => {
    const storedLanguage = localStorage.getItem("selectedLanguage");

    if (storedLanguage && supportedLanguages.includes(storedLanguage)) {
      setSelectedLanguage(storedLanguage);
    } else if (supportedLanguages.includes(browserLanguage)) {
      setSelectedLanguage(browserLanguage);
    } else {
      setSelectedLanguage("en"); // Fallback to default language
    }
  }, [browserLanguage]);



  // Update the message whenever the language changes for this particluar only
  const [message, setMessage] = useState(""); 
  useEffect(() => {
    setMessage(messages[selectedLanguage]["More Options ScreenDesc"]);
  }, [selectedLanguage, messages]);

  const handleDownload = () => {
    const pdfUrl = "/User_Manual_Serene_Browser.pdf"; // Ensure this file is inside the public folder
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "UserManual.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };



  return (
    <IntlProvider
    locale={selectedLanguage}
    messages={messages[selectedLanguage]}
  >
    <div>
    <Header handleLanguageChange={handleLanguageChange} />
      <div class="page-header">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="page-header-box">
                <h1
                  class="text-anime-style-3"
                  style={{ color: "rgb(76, 133, 241)" }}
                >
                 <FormattedMessage id="user_guide" defaultMessage="User Guide" />
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="our-work">
        <div class="container">
          <div class="row section-row align-items-center">
          <div className="d-flex justify-content-between align-items-center">
            <div class="col-lg-8 col-md-9">
              {/* <!-- Section Title Start --> */}
              
              <div class="section-title">
                {/* <h3 class="wow fadeInUp">
                  <FormattedMessage
                    id="Core Capabilities"
                    defaultMessage="Core Capabilities"
                  />
                </h3> */}
                <h2 class="text-anime-style-3">
                  {/* <FormattedMessage
                    id="Step-by-Step Installation Guide"
                    defaultMessage="Step-by-Step Installation Guide"
                  /> */}
                  <FormattedMessage id="user_manual" defaultMessage="User Manual" />
                </h2>
              </div>
                {/* Download Button */}
              
             
           
        
              {/* <!-- Section Title End --> */}
            </div>
            
            <button className="btn btn-primary" onClick={handleDownload}>
                  <FormattedMessage id="download_pdf" defaultMessage="Download PDF" />
                </button>
            </div>
          </div>
             

          <div
            class="row works-item wow fadeInUp"
            style={{ padding: "0px !important;" }}
          >
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime">
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/1.png`}
                      alt=""
                      style={{ width: "50%", height: "auto" }}
                    />
                  </figure>
                </div>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="splash_screen" defaultMessage="Splash Screen" /></h2>
                <p>
                <FormattedMessage id="splash_screen_text" defaultMessage="On start app, this screen is visible until required resources are initialized by OS for the app." />
                </p>
              </div>
            </div>
          </div>
          {/* <!-- Works Item End --> */}

          <div class="row works-item wow fadeInUp" style={{ padding: "0px;" }}>
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime" style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
  }}>
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/2.png`}
                      alt=""
                      style={{ width: "50%", height: "auto", display: "block" }}
                    />
                      <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/3.png`}
                      alt=""
                      style={{ width: "50%", height: "auto",display: "block", marginTop:"10px" }}
                    />
                  </figure>
                </div>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="permissions_screen" defaultMessage="Permissions Screen" /></h2>
                <p>
                <FormattedMessage id="permissions_screen_text" defaultMessage="In this screen, the app asks for permission to take pictures, record video, and record audio." />
                </p>
              </div>
            </div>
          </div>
{/* /////////////////////////// */}
          <div class="row works-item wow fadeInUp" style={{ padding: "0px;" }}>
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime">
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/4.png`}
                      alt=""
                      style={{ width: "50%", height: "auto" }}
                    />
                   
                  </figure>
                </div>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="Language Selection Screen" defaultMessage="Language Selection Screen" /></h2>
                <p>
                <FormattedMessage id="Language Selection ScreenDesc" defaultMessage="Language Selection ScreenDesc" />
                </p>
              </div>
            </div>
          </div>
{/* ////////////////////// */}
{/* /////////////////////////// */}
<div class="row works-item wow fadeInUp" style={{ padding: "0px;" }}>
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime">
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/5.png`}
                      alt=""
                      style={{ width: "50%", height: "auto" }}
                    />
                   
                  </figure>
                </div>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="Browser Home Screen" defaultMessage="Browser Home Screen" /></h2>
                <p>
                <FormattedMessage id="Browser Home ScreenDesc" defaultMessage="Browser Home ScreenDesc" />
                </p>
              </div>
            </div>
          </div>
{/* ////////////////////// */}
{/* /////////////////////////// */}
<div class="row works-item wow fadeInUp" style={{ padding: "0px;" }}>
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime">
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/6.png`}
                      alt=""
                      style={{ width: "50%", height: "auto" }}
                    />
                   
                  </figure>
                </div>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="More Options Screen" defaultMessage="More Options Screen" /></h2>
                <p>
             {message.split("\n").map((line, index) => (
        <span key={index}>
          {line}
          <br />
        </span>
      ))}
                </p>
              </div>
            </div>
          </div>
{/* ////////////////////// */}
{/* /////////////////////////// */}
<div class="row works-item wow fadeInUp" style={{ padding: "0px;" }}>
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime">
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/7.png`}
                      alt=""
                      style={{ width: "50%", height: "auto" }}
                    />
                   
                  </figure>
                </div>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="New Tab Screen" defaultMessage="New Tab Screen" /></h2>
                <p>
                <FormattedMessage id="New Tab ScreenDesc" defaultMessage="New Tab ScreenDesc" />
                </p>
              </div>
            </div>
          </div>
{/* ////////////////////// */}
{/* /////////////////////////// */}
<div class="row works-item wow fadeInUp" style={{ padding: "0px;" }}>
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime">
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/8.png`}
                      alt=""
                      style={{ width: "50%", height: "auto" }}
                    />
                   
                  </figure>
                </div>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="Incognito Tab Screen" defaultMessage="Incognito Tab Screen" /></h2>
                <p>
                <FormattedMessage id="Incognito Tab ScreenDesc" defaultMessage="Incognito Tab ScreenDesc" />
                </p>
              </div>
            </div>
          </div>
{/* ////////////////////// */}
{/* /////////////////////////// */}
<div class="row works-item wow fadeInUp" style={{ padding: "0px;" }}>
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime">
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/9.jpg`}
                      alt=""
                      style={{ width: "50%", height: "auto" }}
                    />
                   
                  </figure>
                </div>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="Tabs Management Screen" defaultMessage="Tabs Management Screen" /></h2>
                <p>
                <FormattedMessage id="Tabs Management ScreenDesc" defaultMessage="Tabs Management ScreenDesc" />
                </p>
              </div>
            </div>
          </div>
{/* ////////////////////// */}
{/* /////////////////////////// */}
<div class="row works-item wow fadeInUp" style={{ padding: "0px;" }}>
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime">
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/10.png`}
                      alt=""
                      style={{ width: "50%", height: "auto" }}
                    />
                   
                  </figure>
                </div>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="Bookmarks Screen" defaultMessage="Bookmarks Screen" /></h2>
                <p>
                <FormattedMessage id="Bookmarks ScreenDesc" defaultMessage="Bookmarks ScreenDesc" />
                </p>
              </div>
            </div>
          </div>
{/* ////////////////////// */}
{/* /////////////////////////// */}
<div class="row works-item wow fadeInUp" style={{ padding: "0px;" }}>
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime">
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/11.jpg`}
                      alt=""
                      style={{ width: "50%", height: "auto" }}
                    />
                   
                  </figure>
                </div>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="Downloads Screen" defaultMessage="Downloads Screen" /></h2>
                <p>
                <FormattedMessage id="Downloads ScreenDesc" defaultMessage="Downloads ScreenDesc" />
                </p>
              </div>
            </div>
          </div>
{/* ////////////////////// */}
{/* /////////////////////////// */}
<div class="row works-item wow fadeInUp" style={{ padding: "0px;" }}>
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime">
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/12.png`}
                      alt=""
                      style={{ width: "50%", height: "auto" }}
                    />
                   
                  </figure>
                </div>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="History Screen" defaultMessage="History Screen" /></h2>
                <p>
                <FormattedMessage id="History ScreenDesc" defaultMessage="History ScreenDesc" />
                </p>
              </div>
            </div>
          </div>
{/* ////////////////////// */}
{/* /////////////////////////// */}
<div class="row works-item wow fadeInUp" style={{ padding: "0px;" }}>
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime">
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/13.png`}
                      alt=""
                      style={{ width: "50%", height: "auto" }}
                    />
                   
                  </figure>
                </div>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="VPN Home Screen" defaultMessage="VPN Home Screen" /></h2>
                <p>
                <FormattedMessage id="VPN Home ScreenDesc" defaultMessage="VPN Home ScreenDesc" />
                </p>
              </div>
            </div>
          </div>
{/* ////////////////////// */}
{/* /////////////////////////// */}
<div class="row works-item wow fadeInUp" style={{ padding: "0px;" }}>
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime">
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/14.png`}
                      alt=""
                      style={{ width: "50%", height: "auto" }}
                    />
                   
                  </figure>
                </div>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="VPN Server List Screen" defaultMessage="VPN Server List Screen" /></h2>
                <p>
                <FormattedMessage id="VPN Server List ScreenDesc" defaultMessage="VPN Server List ScreenDesc" />
                </p>
              </div>
            </div>
          </div>
{/* ////////////////////// */}
{/* /////////////////////////// */}
<div class="row works-item wow fadeInUp" style={{ padding: "0px;" }}>
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime">
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/15.png`}
                      alt=""
                      style={{ width: "50%", height: "auto" }}
                    />
                   
                  </figure>
                </div>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="VPN Network Information Screen" defaultMessage="VPN Network Information Screen" /></h2>
                <p>
                <FormattedMessage id="VPN Network Information ScreenDesc" defaultMessage="VPN Network Information ScreenDesc" />
                </p>
              </div>
            </div>
          </div>
{/* ////////////////////// */}
{/* /////////////////////////// */}
<div class="row works-item wow fadeInUp" style={{ padding: "0px;" }}>
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime">
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/16.png`}
                      alt=""
                      style={{ width: "50%", height: "auto" }}
                    />
                   
                  </figure>
                </div>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="Find on Page Screen" defaultMessage="Find on Page Screen" /></h2>
                <p>
                <FormattedMessage id="Find on Page ScreenDesc" defaultMessage="Find on Page ScreenDesc" />
                </p>
              </div>
            </div>
          </div>
{/* ////////////////////// */}
{/* /////////////////////////// */}
<div class="row works-item wow fadeInUp" style={{ padding: "0px;" }}>
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime">
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/17.png`}
                      alt=""
                      style={{ width: "50%", height: "auto" }}
                    />
                   
                  </figure>
                </div>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="Settings Screen" defaultMessage="Settings Screen" /></h2>
                <p>
                <FormattedMessage id="Settings ScreenDesc" defaultMessage="Settings ScreenDesc" />
                </p>
              </div>
            </div>
          </div>
{/* ////////////////////// */}
{/* /////////////////////////// */}
<div class="row works-item wow fadeInUp" style={{ padding: "0px;" }}>
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime">
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/18.png`}
                      alt=""
                      style={{ width: "50%", height: "auto" }}
                    />
                   
                  </figure>
                </div>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="Security Question Screen" defaultMessage="Security Question Screen" /></h2>
                <p>
                <FormattedMessage id="Security Question ScreenDesc" defaultMessage="Security Question ScreenDesc" />
                </p>
              </div>
            </div>
          </div>
{/* ////////////////////// */}
          <div class="row works-item wow fadeInUp" style={{ padding: "0px;" }}>
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime">
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/19.png`}
                      alt=""
                      style={{ width: "50%", height: "auto" }}
                    />
                   
                  </figure>
                </div>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="set_pin_screen" defaultMessage="Set Pin Screen" /></h2>
                <p>
                <FormattedMessage id="set_pin_screen_text" defaultMessage="On this screen, the user is required to create a PIN to protect the browser from unauthorized access. This PIN must be entered each time the app is opened for the first time or if the app is removed from the recent apps and then reopened, ensuring the authenticity of the users." />
                </p>
              </div>
            </div>
          </div>

          <div class="row works-item wow fadeInUp" style={{ padding: "0px;" }}>
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime">
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/20.png`}
                      alt=""
                      style={{ width: "50%", height: "auto" }}
                    />
                  </figure>
                </div>
                
              </div>
            </div>
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="confirm_pin_screen" defaultMessage="Confirm Pin Screen" /></h2>
                <p>
                <FormattedMessage id="confirm_pin_screen_text" defaultMessage="The user must confirm the PIN by re-entering it after the initial creation. This step ensures that the PIN is correct and will be saved for future use." />
                </p>
              </div>
            </div>
          </div>

          <div class="row works-item wow fadeInUp" style={{ padding: "0px;" }}>
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime">
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/21.png`}
                      alt=""
                      style={{ width: "50%", height: "auto" }}
                    />
                  </figure>
                </div>
              </div>
            </div>

            
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="set_pattern_screen" defaultMessage="Set Pattern Screen" /></h2>
                <p>
                <FormattedMessage id="set_pattern_screen_text" defaultMessage="Users have the option to set either a PIN or a pattern to protect the browser from unauthorized access." />
                </p>
              </div>
            </div>
          </div>

          <div class="row works-item wow fadeInUp" style={{ padding: "0px;" }}>
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime">
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/22.png`}
                      alt=""
                      style={{ width: "50%", height: "auto" }}
                    />
                  </figure>
                </div>
              </div>
            </div>

            
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="confirm_pattern_screen" defaultMessage="Confirm Pattern Screen" /></h2>
                <p>
                <FormattedMessage id="confirm_pattern_screen_text" defaultMessage="The user must confirm the pattern by re-entering it after the initial creation. This step ensures that the pattern is correct and will be saved for future use." />
                </p>
              </div>
            </div>
          </div>         
{/* /////////////////////////// */}
<div class="row works-item wow fadeInUp" style={{ padding: "0px;" }}>
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100vh",
                  }}>
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/23.png`}
                      alt=""
                      style={{ width: "50%", height: "auto", display: "block" }}
                    />
                   <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/24.png`}
                      alt=""
                      style={{ width: "50%", height: "auto",display: "block", marginTop:"10px" }}
                    />
                  </figure>
                </div>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="About Screen" defaultMessage="About Screen" /></h2>
                <p>
                <FormattedMessage id="About ScreenDesc" defaultMessage="About ScreenDesc" />
                </p>
              </div>
            </div>
          </div>
{/* ////////////////////// */}
{/* /////////////////////////// */}
<div class="row works-item wow fadeInUp" style={{ padding: "0px;" }}>
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime">
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/25.png`}
                      alt=""
                      style={{ width: "50%", height: "auto" }}
                    />
                   
                  </figure>
                </div>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="Malicious Url Screen" defaultMessage="Malicious Url Screen" /></h2>
                <p>
                <FormattedMessage id="Malicious Url ScreenDesc" defaultMessage="Malicious Url ScreenDesc" />
                </p>
              </div>
            </div>
          </div>
{/* ////////////////////// */}
{/* /////////////////////////// */}
<div class="row works-item wow fadeInUp" style={{ padding: "0px;" }}>
            <div class="col-md-6 col-lg-6">
              {/* <!-- Works Item Start --> */}
              <div class="wow fadeInUp" data-wow-delay="0.25s">
                <div class="works-image text-center">
                  <figure class="image-anime">
                    <img
                      src={`${process.env.PUBLIC_URL}/Styles/images/26.png`}
                      alt=""
                      style={{ width: "50%", height: "auto" }}
                    />
                   
                  </figure>
                </div>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-6"
              style={{ alignContent: "center", justifyContent: "center" }}
            >
              <div class="works-content">
                <h2><FormattedMessage id="Dark Mode Screens" defaultMessage="Dark Mode Screens" /></h2>
                <p>
                <FormattedMessage id="Dark Mode ScreensDesc" defaultMessage="Dark Mode ScreensDesc" />
                </p>
              </div>
            </div>
          </div>
{/* ////////////////////// */}
         
        </div>
      </div>
      <Footer></Footer>
    </div>
    </IntlProvider>
  );
}

export default UserGuide;
